import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const contact = {
  fetchContacts: lazyModuleMethod(() => import('./fetchContacts'), 'default'),
  updateContact: lazyModuleMethod(() => import('./updateContact'), 'default'),
  fetchContactsPersons: lazyModuleMethod(
    () => import('./fetchContactsPersons'),
    'default'
  ),
  createContactPerson: lazyModuleMethod(
    () => import('./createContactPerson'),
    'default'
  ),
  updateContactPerson: lazyModuleMethod(
    () => import('./updateContactPerson'),
    'default'
  ),
  deleteContactPerson: lazyModuleMethod(
    () => import('./deleteContactPerson'),
    'default'
  ),
  fetchContactsDepartments: lazyModuleMethod(
    () => import('./fetchContactsDepartments'),
    'default'
  ),
  updateContactDepartment: lazyModuleMethod(
    () => import('./updateContactDepartment'),
    'default'
  ),
  deleteContactDepartment: lazyModuleMethod(
    () => import('./deleteContactDepartment'),
    'default'
  ),
  createContactDepartment: lazyModuleMethod(
    () => import('./createContactDepartment'),
    'default'
  ),
}
